import { render, staticRenderFns } from "./edit-deliveryweek.vue?vue&type=template&id=932e3696&scoped=true"
import script from "./edit-deliveryweek.vue?vue&type=script&lang=js"
export * from "./edit-deliveryweek.vue?vue&type=script&lang=js"
import style0 from "./edit-deliveryweek.vue?vue&type=style&index=0&id=932e3696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932e3696",
  null
  
)

export default component.exports